import { PageShell } from '../components/PageShell.tsx';
import { NotFoundContent } from '../components/NotFoundContent.tsx';

export function NotFoundPage() {
  return (
    <PageShell projectName="link">
      <NotFoundContent />
    </PageShell>
  );
}
